import { ErrorHandler, Injectable, Injector } from '@angular/core';

import { ApplicationInsightsService } from './services/application-insights/application-insights.service';

@Injectable({
  providedIn: 'root'
})
export class AppErrorHandler extends ErrorHandler {
  constructor(private readonly injector: Injector) {
    super();
  }

  override handleError(error: any): void {
    const appInsService = this.injector.get(ApplicationInsightsService);
    appInsService.logError(error);
    super.handleError(error);
  }
}
